import { Component, Inject } from '@angular/core';
import { RmsModule } from '@rms';
import { RmsPulldownRef } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';

@Component({
  selector: 'app-payment-preference-form',
  imports: [RmsModule],
  templateUrl: './payment-preference-form.component.html',
  styleUrl: './payment-preference-form.component.scss'
})
export class PaymentPreferenceFormComponent {
  Preference: any = {};

  constructor(@Inject(RMS_PULLDOWN_DATA) private data: any, public ref: RmsPulldownRef) {
    this.Preference = { ...data.preference };
  }

  save() {
    this.ref.close({ ...this.Preference, cancelled: false });
  }

  cancel() {
    this.ref.close({ cancelled: true });
  }
}
